import type { MainNavRoute, MainPath, MainRoute } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

export const ADMIN_TOOLS_TABS = [
  'misc',
  'user_creation',
  'user_edit',
  'localazier',
  'delete_cache',
  'satispay_refund',
  'tenant_duplication',
  'tenant_update',
  'tasks_reset',
  'order_cancellation',
  'order_creation',
  'confirm_batch',
  'delete_stripe_connect_account',
  'massive_import_periods',
  'skipass_delayed',
  'external_widget',
  'massive_tasks_relaunch',
  'elaborate_transit',
  'create_esselunga_discount',
  'check_provider_cash',
  'update_invoice',
  'wallet',
] as const;

export type AdminToolsTabs = (typeof ADMIN_TOOLS_TABS)[number];

const ADMIN_TOOLS_PERMS: Record<AdminToolsTabs, PERMISSIONS[]> = {
  misc: [PERMISSIONS.ADMIN_TOOLS__MISC],
  user_edit: [PERMISSIONS.ADMIN_TOOLS__USER_CREATION],
  user_creation: [PERMISSIONS.ADMIN_TOOLS__USER_CREATION],
  localazier: [PERMISSIONS.ADMIN_TOOLS__LOCALAZIER],
  delete_cache: [PERMISSIONS.ADMIN_TOOLS__DELETE_CACHE],
  satispay_refund: [PERMISSIONS.ADMIN_TOOLS__SATISPAY_REFUND],
  tenant_duplication: [PERMISSIONS.ADMIN_TOOLS__TENANT_DUPLICATION],
  tenant_update: [PERMISSIONS.ADMIN_TOOLS__TENANT_UPDATE],
  tasks_reset: [PERMISSIONS.ADMIN_TOOLS__TASKS_RESET],
  order_cancellation: [PERMISSIONS.ADMIN_TOOLS__ORDER_CANCELLATION],
  order_creation: [PERMISSIONS.ADMIN_TOOLS__ORDER_CREATION],
  confirm_batch: [PERMISSIONS.ADMIN_TOOLS__CONFIRM_BATCH],
  delete_stripe_connect_account: [PERMISSIONS.ADMIN_TOOLS__DELETE_STRIPE_CONNECT_ACCOUNT],
  massive_import_periods: [PERMISSIONS.ADMIN_TOOLS__MASSIVE_IMPORT_PERIODS],
  skipass_delayed: [PERMISSIONS.ADMIN_TOOLS__SKIPASS_DELAYED],
  elaborate_transit: [],
  external_widget: [],
  massive_tasks_relaunch: [],
  create_esselunga_discount: [],
  check_provider_cash: [],
  update_invoice: [],
  wallet: [],
};

export const AdminToolsPath: MainPath = '/admin_tools/:tool';

export const AdminToolsRoutes: MainNavRoute[] = ADMIN_TOOLS_TABS.map((route) => ({
  path: `/admin_tools/${route}` as `/${MainRoute}`,
  label: `routes.admin_tools_${route}`,
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24321/ff6ad524a5fee10',
  permissions: ADMIN_TOOLS_PERMS[route],
  icon: 'gear',
  type: ADMIN_TOOLS_PERMS[route].length ? 1 : 0,
}));
